import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './App.css';
import logo from './logo.png';

function App() {
    const [data, setData] = useState([]);
    const [filters, setFilters] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10); // Set number of items per page

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            setLoading(true);
            const apiUrl = process.env.REACT_APP_API_URL;
            const response = await axios.get(apiUrl);
            const fetchedData = response.data.data || [];
            // Sort the data in descending order (last entry first)
            fetchedData.sort((a, b) => new Date(b.created_date) - new Date(a.created_date));
            setData(fetchedData);
            setLoading(false);
        } catch (error) {
            setError("Error fetching data");
            setLoading(false);
        }
    };

    const handleFilterChange = (e) => {
        setFilters({
            ...filters,
            [e.target.name]: e.target.value
        });
    };

    const filteredData = data.filter(item => {
        return Object.keys(filters).every(key => {
            return !filters[key] || (item[key] && item[key].toString().includes(filters[key]));
        });
    });

    // Pagination Logic
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    return (
        <div className="container">
            <header className="d-flex align-items-center p-3 my-3 text-white bg-dark rounded shadow-sm">
                <img src={logo} alt="EY Logo" />
                <h1 className="h4">Visitor Data</h1>
            </header>

            <div className="filters mb-3">
                {['ipAddress', 'city', 'region', 'country', 'org', 'postal', 'timezone', 'acess_key'].map(field => (
                    <input 
                        key={field}
                        className="form-control mb-2"
                        name={field}
                        placeholder={field.charAt(0).toUpperCase() + field.slice(1)}
                        onChange={handleFilterChange}
                    />
                ))}
            </div>

            {loading && <div>Loading...</div>}
            {error && <div className="alert alert-danger">{error}</div>}

            <div className="table-container">
                <table className="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th><i className="bi bi-globe"></i> IP Address</th>
                            <th><i className="bi bi-building"></i> City</th>
                            <th><i className="bi bi-geo-alt"></i> Region</th>
                            <th><i className="bi bi-flag"></i> Country</th>
                            <th><i className="bi bi-pin-map"></i> Location</th>
                            <th><i className="bi bi-diagram-3"></i> Organization</th>
                            <th><i className="bi bi-envelope"></i> Postal</th>
                            <th><i className="bi bi-clock"></i> Timezone</th>
                            <th><i className="bi bi-person"></i> User Name</th>
                            <th><i className="bi bi-shield-lock"></i> Permissions</th>
                            <th><i className="bi bi-calendar"></i> Created Date</th>
                            <th><i className="bi bi-key"></i> Access Key</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentItems.length > 0 ? currentItems.map((item, index) => (
                            <tr key={index}>
                                <td>{item.ipAddress}</td>
                                <td>{item.city}</td>
                                <td>{item.region}</td>
                                <td>{item.country}</td>
                                <td>{item.loc}</td>
                                <td>{item.org}</td>
                                <td>{item.postal}</td>
                                <td>{item.timezone}</td>
                                <td>{item.user_name}</td>
                                <td>{item.permissions}</td>
                                <td>{item.created_date}</td>
                                <td>{item.acess_key}</td>
                            </tr>
                        )) : <tr><td colSpan="12">No data available</td></tr>}
                    </tbody>
                </table>
            </div>

            {/* Pagination Controls */}
            <div className="pagination">
                <button 
                    className="btn btn-primary"
                    onClick={() => handlePageChange(currentPage - 1)} 
                    disabled={currentPage === 1}>
                    Previous
                </button>

                <span> Page {currentPage} of {totalPages} </span>

                <button 
                    className="btn btn-primary"
                    onClick={() => handlePageChange(currentPage + 1)} 
                    disabled={currentPage === totalPages}>
                    Next
                </button>
            </div>
        </div>
    );
}

export default App;